import { Component, OnInit } from '@angular/core';
import {Route,Router, ActivatedRoute} from '@angular/router';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";

@Component({
  selector: 'app-listemployees',
  templateUrl: './listemployees.component.html',
  styleUrls: ['./listemployees.component.css']
})
export class ListemployeesComponent implements OnInit {

  y:any;
  optional:any;
  slash:any;
  listoredit:any;
  dataarray:any[] = [];
    constructor(private route: ActivatedRoute, private router:Router) {
     }



    ngOnInit() {
      this.route.paramMap.subscribe((params)=>{
        this.slash = params.get('what');
        console.log(this.slash);
        this.listoredit = params.get('listoredit');
        console.log(this.listoredit);
        this.optional = params.get('optional');
      })

      this.y = this.route.snapshot.data['employees'];
      console.log(this.y);
      let namesarray = Object.keys(this.y);
       namesarray.forEach((name)=>{
         this.dataarray.push(this.y[name]);
         console.log(this.dataarray);
       });

    }
  editnavigate(name) {
    console.log(name);
  }
  delete(name){
    let db =  firebase.database();
    let listoredit = this.listoredit;
    let router= this.router;
    let slash = this.slash;
    console.log(listoredit)
    db.ref(this.slash+'/'+name).set(null, function(error){
      if(error){
        alert(error)
      }else{
        alert("You have successfully deleted "+name+" department");
        if(listoredit == 'list'){
        console.log('list');
          router.navigate(['/admin/list/list'+'/', slash ]);

        }else{
        router.navigate(["list"+"/", slash]);
        //  console.log(this.optional);

        }

      }
    })
  }
}
